import { render } from "./Header.vue?vue&type=template&id=8bbd1bf4&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=8bbd1bf4&lang=css"
import "./Header.vue?vue&type=style&index=1&id=8bbd1bf4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbd1bf4"]])

export default __exports__